export enum UserPlan {
  CONOMICA = 'CONOMICA',
  CONOMICA_PLUS = 'CONOMICA_PLUS',
  COWORKER = 'COWORKER',
  OTHER = 'OTHER',
}
